import React from 'react';
import Layout from './Layout.jsx';
import '@amzn/awsui-global-styles/polaris.css';

export class App extends React.Component {
    render() {
        return (
            <div className="awsui">
                <Layout />
            </div>
        );
    }
}

export default App;
